export default {
  vdoLiveSetTopic: {
    id: '',
    vdoLiveSetTopicId: '',
    no: null,
    nameLocal: '',
    nameEng: '',
    vdoLength: 0,
    vdoStreamPath: '',

  },
  vdoLiveSetTopics: [],
  processing: false,
  error: null,
  success: null,
}



